import { i18n } from '../../i18n/translate';
import { copyText } from '../../utils/CopyUtil';
import { displaySuccessMessage, displayErrorMessage } from '../../actions/messagesActions';

export const copyToClipboard = (value: any) => {
  const success = copyText(value);

  if (success) {
    displaySuccessMessage(i18n.t('Copied!'));
  } else {
    displayErrorMessage(i18n.t('Unable to copy'));
  }
};
